import React, { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import BaseModal from 'components/Modals/BaseModal/BaseModal';
import Button from 'components/Button';
import { useAllocateLicensesMutation } from 'core/api/agencies';
import { useModalStore } from 'stores/modal';
import TextInput from 'components/Forms/lib/TextInput';

type Inputs = {
    agencyId: string;
    numLicensesToAllocate: number;
};

type LicenseFormProps = {
    closeModal(): void;
    defaultValues?: any;
};

const LicenseForm: FC<LicenseFormProps> = ({ closeModal, defaultValues }) => {
    const { t } = useTranslation();
    const closeModalStore = useModalStore((state) => state.closeModal);
    const { mutateAsync: allocateLicenses } = useAllocateLicensesMutation();

    const methods = useForm<Inputs>({
        defaultValues,
    });
    const { handleSubmit } = methods;

    const onSubmit = handleSubmit(async (values: Inputs) => {
        try {
            await allocateLicenses({ id: defaultValues.agencyId, inputs: values });
            closeModalStore();
            toast.success(t(`license.${defaultValues?.id ? 'update' : 'creation'}.success`));
        } catch {
            toast.error(t(`license.${defaultValues?.id ? 'update' : 'creation'}.error`));
            closeModalStore();
        }
    });

    return (
        <FormProvider {...methods}>
            <form onSubmit={onSubmit}>
                <TextInput
                    label={t('common.add-license.label')}
                    name="numLicensesToAllocate"
                    placeholder={t('common.add-license.placeholder')}
                    type="number"
                    required
                    semi
                />
                <BaseModal.BottomActions>
                    <Button onClick={() => closeModal()} variant="text">
                        {t('common.cancel')}
                    </Button>
                    <Button submit>{t('common.add')}</Button>
                </BaseModal.BottomActions>
            </form>
        </FormProvider>
    );
};

export default LicenseForm;
